module.exports = __webpack_public_path__ + "static/img/project-gpm-cache.97b2061.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/project-gpm-cache.png
// module id = vJfv
// module chunks = 0